"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontageSetList = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleUtils_1 = require("../ArticleUtils");
const montage_set_1 = require("./montage-set");
const ArticleList_1 = require("../ArticleList");
/**
 * The `MontageSetList` manages a list of `MontageSet`
 */
class MontageSetList extends ArticleList_1.ArticleList {
    constructor() {
        super();
    }
    static fromScratch() {
        return new MontageSetList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new MontageSetList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new MontageSetList();
        list.fromModel(model);
        return list;
    }
    static fromArray(arr) {
        const list = new MontageSetList();
        list.fromArray(arr);
        return list;
    }
    static fromExistingArtNr(json, cloneStrategy = 'deep') {
        const list = new MontageSetList();
        list.fromExistingArtNr(json, cloneStrategy);
        return list;
    }
    static fromInventedArtNr(json, cloneStrategy = 'deep') {
        const list = new MontageSetList();
        list.fromInventedArtNr(json, cloneStrategy);
        return list;
    }
    fromJson(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(montage_set_1.MontageSet.fromJson(itemJson, cloneStrategy));
        }
        this.model = this.items.map((i) => i.toModel());
        this.emitChange();
    }
    fromModel(model) {
        this.items = model.map((m) => montage_set_1.MontageSet.fromModel(m));
        this.model = model;
        this.emitChange();
    }
    fromExistingArtNr(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(montage_set_1.MontageSet.fromExistingArtNr(itemJson, cloneStrategy));
        }
        this.emitChange();
    }
    fromInventedArtNr(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(montage_set_1.MontageSet.fromInventedArtNr(itemJson, cloneStrategy));
        }
        this.emitChange();
    }
    clone() {
        return MontageSetList.fromArray(this.items.map((i) => i.clone()));
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    /**
     * Retrieves the cumulated weight of all MontageSetn in the list.
     *
     * @returns The weight.
     */
    getCumulatedWeight() {
        return echain_shared_quantities_1.Weight.kg(this.items.reduce((cumulatedWeight, montageSet) => cumulatedWeight + (montageSet.gewicht ? montageSet.gewicht.kg : 0), 0));
    }
    /**
     * Returns a new list with MontageSetList filtered by set ArtNrCountry.
     */
    filterByArtNrCountry(artNrCountry) {
        return MontageSetList.fromArray(this.items.filter((article) => article.localizedArtNr && article.localizedArtNr[artNrCountry]));
    }
}
exports.MontageSetList = MontageSetList;
//# sourceMappingURL=montage-set-list.js.map